export const apps = [
	{
		id: 0,
		title: 'MyShop',
		description:
			'MyShop is the second full stack application I have developed. The MERN stack was used to develope the application. One of the new technologies I was introduced to is Redux which a JavaScript library for managing application level state. Furthermore, I worked with MongoDB which is a document based NoSQL database management system. Finally, I worked with NodeJs, which is a JavaScript runtime used to build scalable network applications, to handle all the routes and backend functionality of MyShop. MyShop was then deployed to Heroku using the Heroku CLI.',
		images: [
			'./images/myshop/myshop1.png',
			'./images/myshop/myshop2.png',
			'./images/myshop/myshop3.png',
		],
		html_url: 'http://myshopapp20.herokuapp.com/',
	},
	{
		id: 1,
		title: 'Github Finder',
		description:
			'Github Finder is an application I built to polish my skills on fethcing data from an API and being able to display the information in a presentable manner. This application was built using React. Furthermore I used the Context API in React to manage the application level state. The application was then deployed to Netlify using the Netlify CLI.',
		images: [
			'./images/githubfinder/githubfinder.png',
			'./images/githubfinder/githubfinder1.png',
		],
		html_url: 'https://githubfinderapp7267.netlify.app/',
	},
	// {
	// 	id: 2,
	// 	title: '',
	// 	description: '',
	// 	img_url: '',
	// 	html_url: '',
	// },
]
